import { useSyncExternalStore } from "react";
let storageKey = "enlixy-theme";
let started = false;
const listeners = new Set();
const media = () => window.matchMedia("(prefers-color-scheme: dark)");
function read() {
    try {
        return localStorage.getItem(storageKey);
    }
    catch {
        return null;
    }
}
export function themeChoice() {
    const v = read();
    return v === "light" || v === "dark" ? v : "system";
}
export function isDark() {
    const c = themeChoice();
    return c === "dark" || (c === "system" && media().matches);
}
function apply() {
    document.documentElement.classList.toggle("dark", isDark());
    listeners.forEach((l) => l());
}
export function setTheme(choice) {
    try {
        if (choice === "system")
            localStorage.removeItem(storageKey);
        else
            localStorage.setItem(storageKey, choice);
    }
    catch {
        /* private mode: applies to this page only */
    }
    apply();
}
export function toggleTheme() {
    setTheme(isDark() ? "light" : "dark");
}
/**
 * Applies the stored theme before the first render (no flash) and follows
 * the system setting. Call once in main.tsx. storageKey: keep an app's
 * existing key so users keep their choice.
 */
export function initTheme(opts = {}) {
    if (opts.storageKey)
        storageKey = opts.storageKey;
    apply();
    if (started)
        return;
    started = true;
    media().addEventListener("change", () => {
        if (themeChoice() === "system")
            apply();
    });
}
export function subscribeTheme(cb) {
    listeners.add(cb);
    return () => {
        listeners.delete(cb);
    };
}
/** dark: what is shown; choice: light, dark or system. */
export function useTheme() {
    const dark = useSyncExternalStore(subscribeTheme, isDark);
    const choice = useSyncExternalStore(subscribeTheme, themeChoice);
    return { dark, choice, setChoice: setTheme, toggle: toggleTheme };
}
